import { createQuery } from '@tanstack/svelte-query';
import { fetchDINChannels, fetchDINChannelsByModule } from '$lib/api/din_channel';
import { resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { DINChannelResponse } from '$lib/types/din_channel';

export const dinChannelsQuery = () =>
  createQuery<Array<DINChannelResponse>>(() => ({
    queryKey: ['din_channels'],
    queryFn: () => fetchDINChannels()
  }));

export const dinChannelsByModuleQuery = (getModuleId: number | ScopeFn) =>
  createQuery<Array<DINChannelResponse>>(() => {
    const moduleId = resolveScope(getModuleId);
    return {
      queryKey: ['din_channels', { moduleId }],
      queryFn: () => fetchDINChannelsByModule(moduleId),
      enabled: moduleId > 0
    };
  });
